export const FIRST_COMPANY_SURVEY_LIST = "FIRST_COMPANY_SURVEY_LIST";
export const SECOND_COMPANY_SURVEY_LIST = "SECOND_COMPANY_SURVEY_LIST";
export const SET_COMPARISON_REPORT = "SET_COMPARISON_REPORT";
export const SET_COMPARISON_NAMES = "SET_COMPARISON_NAMES";
export const FETCH_STATUS = "FETCH_STATUS";
export const SET_COMPARISON_TREE = "SET_COMPARISON_TREE";
export const END_COMPARISON = "END_COMPARISON";
export const GET_SURVEY_TREE = "GET_SURVEY_TREE";